/**
 * This class will handle the more load functionality
 */
class MoreLoad {
    /**
     * Constructor for the MoreLoad class
     */
    constructor() {
        this.articleListContainer = document.querySelectorAll('.js-collapsible-article-list');
    }

    /**
     * This method will be called when the page is loaded
     */
    init() {
        this.bindEvents();
    }

    /**
     * This method will bind the events to the elements
     */
    bindEvents() {
        if (this.articleListContainer.length) {
            this.articleListContainer.forEach((container) => {
                const articleShowMore = container.parentElement.querySelector('.js-article-show-more');
                const articleShowLess = container.parentElement.querySelector('.js-article-show-less');
                const articleItems = container.querySelectorAll('.article-item');
                const amountOfElements = parseInt(container.dataset.limitDisplayArticles) || 5;

                // Convert NodeList to Array and sort by data-idx attribute
                const articleItemsArr = this.hasMobileDetected() ? [...articleItems]
                    : [...articleItems].sort((a, b) => {
                    const aIdx = parseInt(a.dataset.idx) || 0;
                    const bIdx = parseInt(b.dataset.idx) || 0;
                    return aIdx - bIdx;
                });

                // Initially hide articles beyond the limit
                for (let index = 0; index < articleItemsArr.length; ++index) {
                    const element = articleItemsArr[index];
                    if (index >= amountOfElements) {
                        element.classList.add('is-hidden');
                    }
                }

                // Show more articles on button click
                if (articleShowMore) {
                    articleShowMore.addEventListener('click', (event) => {
                        // First, remove the hidden class from all articles
                        for (let index = 0; index < articleItemsArr.length; ++index) {
                            const element = articleItemsArr[index];
                            element.classList.remove('is-hidden');
                        }

                        articleShowMore.classList.add('is-hidden');
                        articleShowLess.classList.remove('is-hidden');

                        // After revealing articles, scroll to 20px above the first newly visible article
                        if (articleItemsArr.length > amountOfElements) {
                            const firstNewlyVisibleArticle = articleItemsArr[amountOfElements];
                            this.scrollToElementWithOffset(firstNewlyVisibleArticle);
                        }
                    });
                }

                // Show less articles on button click
                if (articleShowLess) {
                    articleShowLess.addEventListener('click', (event) => {
                        for (let index = 0; index < articleItemsArr.length; ++index) {
                            const element = articleItemsArr[index];
                            if (index >= amountOfElements) {
                                element.classList.add('is-hidden');
                            }
                        }

                        articleShowMore.classList.remove('is-hidden');
                        articleShowLess.classList.add('is-hidden');

                        // Scroll back to 20px above the first article
                        if (articleItemsArr.length > 0) {
                            const firstArticle = articleItemsArr[0];
                            this.scrollToElementWithOffset(firstArticle);
                        }
                    });
                }
            });
        }
    }

    /**
     * This method will scroll to the element with an offset
     *
     * @param element
     * @param offset
     */
    scrollToElementWithOffset = (element, offset = 90) => {
        setTimeout(() => {
            // Get the element's position relative to the viewport
            const rect = element.getBoundingClientRect();
            // Calculate the absolute position on the page
            const absoluteTop = rect.top + window.scrollY;
            // Subtract the offset to position above the element
            const scrollToPosition = absoluteTop - offset;

            // Scroll to the calculated position
            window.scrollTo({
                top: scrollToPosition,
                behavior: 'smooth'
            });
        }, 50);
    }

    hasMobileDetected() {
        const isMobileUserAgent = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(this.userAgent);
        const hasTouchScreen = (
            ('ontouchstart' in window) ||
            (navigator.maxTouchPoints > 0)
        );

        return (hasTouchScreen || isMobileUserAgent);
    }
}

export default new MoreLoad();